import { useCallback, useMemo } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { TASKS_CONFIGS } from '../../../../constants';
import { useCompleteTaskByCheckbox } from '../../../../hooks/useNextSteps/useTasks/useCompleteTaskByCheckbox';
import type { Task } from '../../../../types';

type ExistingTask = Readonly<{ id: Task['id']; name: Task['name']; status: Task['status'] }>;

type CheckboxAction = () => Promise<void>;

export function useDynamicCheckboxAction(): (featureKey: string | null) => CheckboxAction | undefined {
	const { data } = useStarterDashboardV2PageData();
	const getCheckboxHandler = useCompleteTaskByCheckbox();

	const existingTasksByName = useMemo<ReadonlyMap<string, ExistingTask>>(() => {
		const { activeTasks } = data.petition;
		if (activeTasks.__typename !== 'PetitionTasksConnection') return new Map();
		return new Map(activeTasks.nodes.map((task) => [task.name, task]));
	}, [data.petition]);

	return useCallback(
		(featureKey: string | null) => {
			if (!featureKey || !Object.hasOwn(TASKS_CONFIGS, featureKey)) return undefined;
			const existingTask = existingTasksByName.get(featureKey);
			if (!existingTask) return undefined;
			return getCheckboxHandler(existingTask.id, existingTask.name, existingTask.status);
		},
		[getCheckboxHandler, existingTasksByName],
	);
}
